export default __webpack_public_path__ + "static/media/sort_arrow_icon.c803033b.svg";